import { useState } from "react";
export const useHorizontalSwipe = (containerRef) => {
    const [startX, setStartX] = useState(0);
    const [currentX, setCurrentX] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const handleTouchStart = (e) => {
        if (!containerRef.current || containerRef.current.clientWidth >= containerRef.current.scrollWidth)
            return;
        setIsDragging(true);
        setStartX(e.touches[0].clientX - currentX);
    };
    const updatePosition = (newX) => {
        const containerWidth = containerRef.current.clientWidth;
        const itemsWidth = containerRef.current.scrollWidth;
        const minTranslateX = Math.min(0, containerWidth - itemsWidth);
        const maxTranslateX = 0;
        const newCurrentX = Math.min(maxTranslateX, Math.max(minTranslateX, newX));
        if (newCurrentX === currentX)
            return;
        setCurrentX(newCurrentX);
    };
    const handleTouchMove = (e) => {
        if (!isDragging || !containerRef.current)
            return;
        const newX = e.touches[0].clientX - startX;
        updatePosition(newX);
    };
    const handleTouchEnd = () => {
        setIsDragging(false);
    };
    return {
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onTouchEnd: handleTouchEnd,
        elementPositionX: currentX,
    };
};
//# sourceMappingURL=useHorizontalSwipe.js.map